import api from '@services/api';
import { DetailsRequest, UndoUnionDetailsRequest, UnitDetailsRequest } from '../models/details';
import { ThirdServiceResponse, ThirdServiceTransfer, UpdateThirdService } from '../models/detailsThirdService';

/**
 * <p>
 * API endpoints that cover all third service related CRUD calls
 */
export const detailsThirdServiceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchDetailsThirdService: builder.query<ThirdServiceResponse, DetailsRequest>({
      query: (params: DetailsRequest) => ({
        url: encodeURI(
          `/report/details-third-service/search?searchTerm=${params.searchTerm}&projectCode=${params.project}&period=${params.period}&subgroup=${params.subGroup}`,
        ),
      }),
      providesTags: ['SearchDetailsThirdService', 'SearchDetails'],
    }),
    unitThirdService: builder.mutation<void, UnitDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-third-service/group`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsThirdService'],
    }),
    undoUnionThirdService: builder.mutation<void, UndoUnionDetailsRequest>({
      query: (project) => ({
        url: encodeURI(`/report/details-third-service/ungroup`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsThirdService'],
    }),
    updateDetailsThirdService: builder.mutation<void, UpdateThirdService>({
      query: (project) => ({
        url: encodeURI(`/report/details-third-service/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsThirdService'],
    }),
    thirdServiceTransfer: builder.mutation<void, ThirdServiceTransfer>({
      query: (project) => ({
        url: encodeURI(`/report/details-third-service/transfer`),
        method: 'POST',
        body: project,
      }),
      invalidatesTags: ['SearchDetailsThirdService', 'SearchDetails'],
    }),
  }),
});

export const {
  useSearchDetailsThirdServiceQuery,
  useUnitThirdServiceMutation,
  useUndoUnionThirdServiceMutation,
  useUpdateDetailsThirdServiceMutation,
  useThirdServiceTransferMutation,
} = detailsThirdServiceApi;
